import React, { createContext, useContext, useState } from 'react';

// Iter 539 (Kamel) — accordéon « handicap numérique » : UNE rubrique ouverte à la fois,
// consigne « Appuyez pour ouvrir / refermer » écrite, bouton Refermer aussi en bas.
const Ctx = createContext({ val: null, set: () => {} });

export const Accordeon = ({ ouvert, onChange, defaut = null, children, className = 'space-y-2' }) => {
  const [interne, setInterne] = useState(defaut);
  const controle = ouvert !== undefined;
  const val = controle ? ouvert : interne;
  const set = (id) => { if (onChange) onChange(id); if (!controle) setInterne(id); };
  return <Ctx.Provider value={{ val, set }}><div className={className}>{children}</div></Ctx.Provider>;
};

const TONS = {
  bleu: 'bg-sky-100 text-sky-900', vert: 'bg-emerald-100 text-emerald-900', ambre: 'bg-amber-100 text-amber-900',
  violet: 'bg-purple-100 text-purple-900', gris: 'bg-gray-100 text-gray-700', rouge: 'bg-red-100 text-red-800', rose: 'bg-pink-100 text-pink-900',
};

export const Rubrique = ({ id, icone, titre, resume, badge, ton = 'bleu', children }) => {
  const { val, set } = useContext(Ctx);
  const open = val === id;
  return (
    <section className={`rounded-2xl border-2 bg-white shadow-sm overflow-hidden transition-colors scroll-mt-32 ${open ? 'border-[#1E3A5F]' : 'border-gray-200'}`}
      data-testid={`rubrique-${id}`} id={`rubrique-${id}`}>
      <button type="button" onClick={() => set(open ? null : id)} aria-expanded={open} data-testid={`rubrique-toggle-${id}`}
        className="w-full text-left px-3.5 py-3 flex items-center gap-3 min-h-[60px] hover:bg-gray-50 active:bg-gray-100">
        <span className={`h-10 w-10 flex-shrink-0 rounded-xl flex items-center justify-center text-xl ${TONS[ton] || TONS.bleu}`} aria-hidden="true">{icone}</span>
        <span className="flex-1 min-w-0">
          <span className="block text-sm font-bold text-[#1E3A5F]">{titre}</span>
          {resume && !open && <span className="block text-xs text-gray-600 truncate" data-testid={`rubrique-resume-${id}`}>{resume}</span>}
          <span className="block text-[10px] text-gray-400">{open ? '▴ Appuyez ici pour refermer' : '▾ Appuyez ici pour ouvrir'}</span>
        </span>
        {badge}
        <span className="text-[#1E3A5F] text-2xl leading-none flex-shrink-0" aria-hidden="true">{open ? '▴' : '▾'}</span>
      </button>
      {open && (
        <div className="px-3.5 pb-3.5 pt-3 space-y-3 border-t border-gray-100" data-testid={`rubrique-contenu-${id}`}>
          {children}
          <button type="button" onClick={() => set(null)} data-testid={`rubrique-replier-${id}`}
            className="w-full text-center text-sm font-bold text-[#1E3A5F] bg-gray-50 border border-gray-200 rounded-xl py-3 hover:bg-gray-100">
            ▴ Refermer « {titre} »
          </button>
        </div>
      )}
    </section>
  );
};
